<h5 class="text-center" style="font-size: 21px;">Are you sure you want to delete this User?</h5>
<div class="text-center p-2 m-2">
    <button mat-raised-button id="model-cancel-button" class="btn btn-primary m-4" (click)="deleteModule()">Confirm</button>
    <button mat-raised-button id="model-cancel-button" class="btn btn-danger m-4" (click)="closeModel()">Cancel</button>
    
</div>
